// src/MathBoard.js
import React, { useState, useEffect, useRef } from 'react';
import { generateMathQuiz } from './mathLogic';
import html2canvas from 'html2canvas';

const MathBoard = ({ onAddToBook, seed = null }) => {
  const [questions, setQuestions] = useState([]);
  const [difficulty, setDifficulty] = useState('medium');
  const [showSolution, setShowSolution] = useState(false); // زر الحل
  const printRef = useRef();

  const createQuiz = () => {
    // نولدو 16 سؤال باش تجي الورقة عامرة ومقادة (2 أعمدة × 8 صفوف)
    const quiz = generateMathQuiz(16, difficulty, seed); 
    setQuestions(quiz);
    setShowSolution(false); // نخبيو الحل فاش نديرو لعبة جديدة
  };

  useEffect(() => { createQuiz(); }, [difficulty, seed]);

  const handleAddToBook = () => {
    if (printRef.current) {
      // نخبيو الحل قبل التصوير
      const wasShowing = showSolution;
      setShowSolution(false);

      setTimeout(() => {
        html2canvas(printRef.current).then((canvas) => {
          // إرسال الصعوبة مع الـ Seed
          onAddToBook('Math', canvas.toDataURL(), { seed, difficulty });
          if(wasShowing) setShowSolution(true); // نرجعو الحل
        });
      }, 100);
    }
  };

  return (
    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h2 style={{color: '#2d3436', fontFamily: 'sans-serif'}}>
        Math Quiz ➗ 
        {seed && <span style={{fontSize:'0.6em', color:'gray', marginLeft:'10px'}}>ID: {seed}</span>}
      </h2>

      {/* إخفاء التحكم إذا كنا فوضع المعاينة (Seed موجود) */}
      {!seed && (
        <div style={{ marginBottom: '20px', background: 'white', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', display:'flex', gap:'10px', flexWrap:'wrap', justifyContent:'center' }}>
          <select value={difficulty} onChange={(e) => setDifficulty(e.target.value)} style={{padding:'10px', borderRadius:'5px', border:'1px solid #ccc'}}>
            <option value="easy">Easy (Add/Sub)</option>
            <option value="medium">Medium (Mix)</option>
            <option value="hard">Hard (Multiplication)</option>
          </select>
          
          <button onClick={createQuiz} style={btnStyle('#6c5ce7')}>🔄 New</button>
          
          {/* زر الحل */}
          <button onClick={() => setShowSolution(!showSolution)} style={btnStyle(showSolution ? '#e17055' : '#00b894')}>
            {showSolution ? 'Hide' : 'Solution'}
          </button>
          
          <button onClick={handleAddToBook} style={btnStyle('#e67e22')}>📖 Add</button>
        </div>
      )}

      {/* ورقة التمارين (هادي هي اللي غتطبع) */}
      <div ref={printRef} style={{ 
          padding: '40px', background: 'white', width: '100%', maxWidth: '700px', 
          border: seed ? 'none' : '1px solid #eee',
          display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px 60px' // gap عمودي وأفقي
        }}>
        {questions.map((q) => (
          <div key={q.id} style={{ 
            fontSize: '28px', borderBottom: '2px dashed #b2bec3', padding: '10px', 
            display:'flex', justifyContent:'space-between', alignItems:'center',
            fontFamily: 'Courier New, monospace', fontWeight:'bold', color: '#2d3436'
          }}>
            {/* المعادلة */}
            <span>{q.num1} {q.operator} {q.num2} = </span>
            
            {/* مكان الجواب */}
            <span style={{
              color: showSolution ? '#d63031' : '#dfe6e9', // أحمر للحل، رمادي للفراغ
              minWidth: '50px', textAlign: 'right'
            }}>
              {showSolution ? q.answer : '___'}
            </span> 
          </div>
        ))}
      </div>
    </div>
  );
};

const btnStyle = (bg) => ({ background: bg, color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' });

export default MathBoard;